import ComponentElement from 'components/component-element';
import Swiper from 'vendor_components/swiper.min';

function SelectionsSlider($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$swiper = this.$element.querySelector('.swiper');

    new Swiper(this.$swiper, Object.assign({
        slidesPerView: 'auto',
        spaceBetween: 8,
        speed: 300,
        navigation: {
            prevEl: this.$element.querySelector('.Selections__prev'),
            nextEl: this.$element.querySelector('.Selections__next'),
        },
        pagination: {
            enabled: true,
            type: 'bullets',
            el: this.$element.querySelector('.js-selectionsPagination'),
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 20,
                pagination: {
                    enabled: false,
                    el: null,
                },
            },
        },
    }, this.options.swiper));
}

SelectionsSlider.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(SelectionsSlider, 'constructor', {
    value: SelectionsSlider,
    writable: true,
    enumerable: false,
});

SelectionsSlider.prototype.setOptions = function(options) {
    return ComponentElement.prototype.setOptions.call(this, Object.assign({
        swiper: {
            //
        },
    }, options));
}

export default SelectionsSlider;
